import { Tabs } from "components"
import { useState, useEffect } from "react"
import { Graphic } from "../../CountValueData/Graphic"
import { CounterGraph } from "components"
import { CounterValueTable } from "components"
import { OccupancyGraph } from "components"
import { useFetchCountingValuesMutation } from "../../../store/Features/processData/countingValues-api-slice"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

import { useSelector } from "react-redux"
interface CheckboxValues {
 occupancy: boolean
 counter: boolean
}

interface IDate {
 begin: string
 end: string
}
export const Graph = ({
 showGraphChart,
 setShowGraphChart,
 setShowTableChart,
 showTableChart,
 isOpen,
}: {
 showGraphChart: boolean
 setShowGraphChart: (_value: boolean) => void
 showTableChart: boolean
 setShowTableChart: (_value: boolean) => void
 isOpen: boolean
}) => {
      // language translator
      const { t } = useTranslation("translation")
 const [data, setData] = useState([])
 const [selectedDetectors, setSelectedDetectors] = useState<string[]>([])
 const [selectAll, setSelectAll] = useState(false)
 const [checkboxValues, setCheckboxValues] = useState<CheckboxValues>({
  occupancy: false,
  counter: false,
 })
 const [date, setDate] = useState<IDate>({ begin: "", end: "" })
 const [FetchCounterValues] = useFetchCountingValuesMutation()

 const handleFetchCounterValues = () => {
  FetchCounterValues(date)
   .then((res: any) => {
    setData(res.data)
   })
   .catch((e: any) => {
    console.log("e", e)
   })
 }

 const Ids = useSelector((state: any) => state.selectedDevicesIds)
 const _selectedDeviceData =
  data && data?.filter((item: any) => Ids.deviceIds.includes(item.common_information.device_id))

 // Create a Set to store unique detector names
 const uniqueDetectorNamesSet = new Set()

 // Iterate over the data array and populate the Set
 data &&
  _selectedDeviceData &&
  _selectedDeviceData?.forEach((item: any) => {
   item.oepnv_data_elements.forEach((element: any) => {
    element.detector_list.forEach((detector: any) => {
     uniqueDetectorNamesSet.add(detector.detector_name)
    })
   })
  })
 const _SingleDetectorName = Array.from(uniqueDetectorNamesSet)

 const handleDetectorCheckboxChange = (detectorName: string) => {
  setSelectedDetectors((prevDetectors) => {
   const updatedDetectors = prevDetectors.includes(detectorName)
    ? prevDetectors.filter((name) => name !== detectorName)
    : [...prevDetectors, detectorName]

   // Check if all detectors are selected after the change
   const allDetectorsSelected = updatedDetectors.length === _SingleDetectorName.length

   // Update the state of "Select All" checkbox
   setSelectAll(allDetectorsSelected)

   return updatedDetectors
  })
 }

 const handleSelectAllChange = () => {
  // Toggle the state of "all" checkbox
  setSelectAll(!selectAll)

  // If "all" is selected, update the state with all detector names
  const updatedDetectors: any = !selectAll ? _SingleDetectorName : []

  setSelectedDetectors(updatedDetectors)
 }

 const handleCheckboxChange = (checkboxId: string) => {
  setCheckboxValues((prevValues: any) => ({
   ...prevValues,
   [checkboxId]: !prevValues[checkboxId],
  }))
 }

 const items = [
  {
   key: "1",
   label: t("table"),
   children: (
    <div>
     <Graphic
      setCheckboxValues={setCheckboxValues}
      checkboxValues={checkboxValues}
      handleCheckboxChange={handleCheckboxChange}
      setShowGraphChart={setShowGraphChart}
      setShowTableChart={setShowTableChart}
      isTable={true}
      date={date}
      setDate={setDate}
      handleFetchCounterValues={handleFetchCounterValues}
     />
    </div>
   ),
  },
  {
   key: "2",
   label: t("graphic"),
   children: (
    <div>
     <Graphic
      setCheckboxValues={setCheckboxValues}
      checkboxValues={checkboxValues}
      handleCheckboxChange={handleCheckboxChange}
      setShowGraphChart={setShowGraphChart}
      setShowTableChart={setShowTableChart}
      isTable={false}
      date={date}
      setDate={setDate}
      handleFetchCounterValues={handleFetchCounterValues}
     />
    </div>
   ),
  },
  {
   key: "3",
   label: t("download"),
   children: "Download",
  },
 ]
 useEffect(() => {
  localStorage.setItem("checkboxValues", JSON.stringify(checkboxValues))
  const storedCheckboxValues = localStorage.getItem("checkboxValues")
  if (storedCheckboxValues) {
   setCheckboxValues(JSON.parse(storedCheckboxValues))
  }
 }, [])

 const [activeTab, setActiveTab] = useState(items[0].key)

 return (
  <Box bg="body_gray" color="text-black">
   {isOpen && (
    <Tabs value={activeTab} onChange={(key: string) => setActiveTab(key)} items={items} />
   )}
   {showTableChart && (
    <div>
     <CounterValueTable _selectedDeviceData={_selectedDeviceData} />
    </div>
   )}
   {showGraphChart && (
    <div className="relative">
     {checkboxValues?.counter && (
      <>
       <CounterGraph
        checkboxValues={checkboxValues}
        selectedDetectors={selectedDetectors}
        _selectedDeviceData={_selectedDeviceData ? _selectedDeviceData : []}
        data={data}
       />
       <div className="mt-2 whitespace-nowrap h-[280px] overflow-y-auto hide-scroll-icon rounded  bg-gray absolute top-0 right-0 ">
        <div className="bg-golden text-white mb-2 px-2">{t("deviceList")}</div>
        <div className="px-1">
         <div className="custom-checkbox">
          <input
           type="checkbox"
           id="test"
           checked={selectAll}
           onChange={handleSelectAllChange}
           className=""
          />
          <label className="font-semibold font-sm Jakarta-font" htmlFor="test">
          {t("all")}
          </label>
         </div>

         {data &&
          data?.length &&
          _selectedDeviceData &&
          _SingleDetectorName.map((detector: any, index: number) => (
           <div key={index} className="custom-checkbox">
            <input
             type="checkbox"
             id={detector}
             checked={selectedDetectors.includes(detector)}
             onChange={() => handleDetectorCheckboxChange(detector)}
           
            />
            <label className="font-semibold font-sm Jakarta-font" htmlFor={detector}>
             {detector}
            </label>
           </div>
          ))}
        </div>
       </div>{" "}
      </>
     )}
     {checkboxValues?.occupancy && (
      <>
       {" "}
       <OccupancyGraph
        checkboxValues={checkboxValues}
        selectedDetectors={selectedDetectors}
        _selectedDeviceData={_selectedDeviceData}
        data={data}
       />
       <div className="mt-2 whitespace-nowrap h-[280px] overflow-y-auto hide-scroll-icon rounded  bg-gray absolute top-0 right-0 ">
        <div className="bg-golden text-white mb-2 px-2">{t("deviceList")}</div>
        <div className="px-1">
         <div className="custom-checkbox">
          <input
           type="checkbox"
           id="test"
           checked={selectAll}
           onChange={handleSelectAllChange}
           className=""
          />
          <label className="font-semibold font-sm Jakarta-font" htmlFor="test">
        {t("all")}
          </label>
         </div>

         {_selectedDeviceData &&
          _SingleDetectorName.map((detector: any, index: number) => (
           <div key={index} className="custom-checkbox">
            <input
             type="checkbox"
             id={detector}
             checked={selectedDetectors.includes(detector)}
             onChange={() => handleDetectorCheckboxChange(detector)}
             className=""
            />
            <label className="font-semibold font-sm Jakarta-font" htmlFor={detector}>
             {detector}
            </label>
           </div>
          ))}
        </div>
       </div>{" "}
      </>
     )}
    </div>
   )}
  </Box>
 )
}
